<template>
  <div class="">
    <mobile-portrait-dummy/>
    <lesson1/>
  </div>
</template>
<script>
import Lesson1 from '@/components/lessons/components/lesson1/lesson1'
import MobilePortraitDummy from '@/components/MobilePortraitDummy/MobilePortraitDummy'

export default {
  name: 'Home',
  components: {
    MobilePortraitDummy,
    Lesson1,
  },
}
</script>
<style lang="scss" module>
@import './Home.scss';
</style>
